import { ChangeEvent, useCallback, useMemo } from 'react'
import { setOrderPrice, setOrderTotal } from 'state/exchange/reducer'
import { selectCurrentMarketInfo, selectOrderDirection, selectOrderPrice, selectOrderSize, selectOrderType } from 'state/exchange/selectors'

import { useAppDispatch, useAppSelector } from 'state/hooks'
import { selectCurrentMarketPrice, selectOraclePrices } from 'state/prices/selectors'

import OrderPriceInput from './OrderPriceInput'

export default function TradePanelPriceInput() {
	const dispatch = useAppDispatch()

	const marketPrice = useAppSelector(selectCurrentMarketPrice)
	const leverageSide = useAppSelector(selectOrderDirection)
	const orderPrice = useAppSelector(selectOrderPrice)
	const orderType = useAppSelector(selectOrderType)
	const orderSize = Number(useAppSelector(selectOrderSize))
	const oraclePrices = useAppSelector(selectOraclePrices)
	const pariInfo = useAppSelector(selectCurrentMarketInfo)

	const handleOnChange = useCallback(
		(_: ChangeEvent<HTMLInputElement>, v: string) => {
			const price = Number(v)
			const total = price * orderSize
			dispatch(setOrderPrice(v))
			dispatch(setOrderTotal(total.toString()))
		},
		[dispatch, orderSize]
	)

	const oraclePrice = useMemo(() => {
		return oraclePrices[pariInfo?.tokenY.symbol || '']
	}, [pariInfo, oraclePrices])

	return (
		<OrderPriceInput
			orderType={orderType}
			orderPrice={orderPrice}
			oraclePrice={oraclePrice}
			positionSide={leverageSide}
			marketPrice={marketPrice}
			quoteSymbol={pariInfo?.tokenY.symbol ?? ''}
			onChange={handleOnChange}
		/>
	)
}
